import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { API } from "../App";
import { HardHat, LogIn } from "lucide-react";

const EmployeeLoginPage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) { toast.error("Email and password required"); return; }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/employees/login`, form, { withCredentials: true });
      toast.success(`Welcome, ${res.data.name}!`);
      navigate("/employee");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0B0C10] flex items-center justify-center p-4" data-testid="employee-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-[#FF6B35]/20 flex items-center justify-center mx-auto mb-4">
            <HardHat size={32} className="text-[#FF6B35]" />
          </div>
          <h1 className="text-2xl font-bold text-white">Team Portal</h1>
          <p className="text-[#A0AAB2] text-sm mt-1">New Leaf PMC LLC</p>
        </div>
        <form onSubmit={handleLogin} className="bg-[#15161C] border border-[#2A2B32] rounded-xl p-6 space-y-4">
          <div>
            <label className="text-[#A0AAB2] text-sm mb-1 block">Email</label>
            <input type="email" value={form.email} onChange={e => setForm(p => ({...p, email: e.target.value}))}
              className="w-full bg-[#1F2027] border border-[#2A2B32] rounded-lg px-4 py-3 text-white" placeholder="you@company.com" data-testid="emp-login-email" />
          </div>
          <div>
            <label className="text-[#A0AAB2] text-sm mb-1 block">Password</label>
            <input type="password" value={form.password} onChange={e => setForm(p => ({...p, password: e.target.value}))}
              className="w-full bg-[#1F2027] border border-[#2A2B32] rounded-lg px-4 py-3 text-white" placeholder="Your password" data-testid="emp-login-password" />
          </div>
          <button type="submit" disabled={loading} data-testid="emp-login-submit"
            className="w-full gradient-btn py-3 rounded-lg font-semibold flex items-center justify-center space-x-2 disabled:opacity-50">
            <LogIn size={18} /><span>{loading ? "Signing in..." : "Sign In"}</span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default EmployeeLoginPage;
